import React from 'react';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import UropProjects from '../components/urop_projects/UropProjects';

const UropPage = () => (
  <Layout>
    <SEO
      title='UROP Projects | MIT Biomimetic Robotics Lab'
      description='UROP Projects page for the MIT Biomimetic Robotics Lab'
    />
    <UropProjects />
  </Layout>
);

export default UropPage;
